<template>
    <div>
        <slot :data="data"
            :vars="vars"
            :comentar="comentar"
            :avanzar="avanzar"
            :retroceder="retroceder"
            :reactivar="reactivar"
            :congelar="congelar"
            :descartar="descartar"
            :pos="pos"
            :anterior="anterior"
            :siguiente="siguiente"
            :navegar="navegar"
            :count="count"
            :menu="menu"
            :af="af"
            :crearFamiliar="crearFamiliar"
            :sendResetPassword="sendResetPassword"
            :desvincularUsuario="desvincularUsuario"            
            :crearAccesosLanding="crearAccesosLanding"
            :editarFamiliar="editarFamiliar"
            :seleccionarFamiliar="seleccionarFamiliar"
            :seleccionarTutor="seleccionarTutor"
            :limpiar="limpiar"
            :status="status"
            :headersBeca="headersBeca"
            :desvincularFamiliar="desvincularFamiliar"
            :familiarVinculoSelected="familiarVinculoSelected"
            :familiaresHijos="familiaresHijos"
            :quitarVinculo="quitarVinculo"
            :enviarCorreoModal="enviarCorreoModal"
            :abrirCorreoModal="abrirCorreoModal"
            :reload="reload"
            :ticketModal="ticketModal"
            :abrirTicketModal="abrirTicketModal"
            :userSelected="userSelected"
            :comunicadoModal="comunicadoModal"
            :comView="comView"
            :selectCom="selectCom"
            :comMensajes="comMensajes"
            :formatearFecha="formatearFecha"
            :comBack="comBack"
            :comSelected="comSelected"
            :comResponder="comResponder"
            >
        </slot>
    </div>
</template>

<script>
import Axios from 'axios';
import moment from "moment";
moment.locale('es');

export default {
    props: [
        'ruta',
        'institucion_filtro'
    ],
    data() { return {
        vars: {
            comentario: '',
        },
        data: {},
        lista: [],
        menu: [],
        control: {},
        af: {
            "apellido_paterno":"",
            "apellido_materno":"",
            "nombres":"",
            "celular":"",
            "telefono_casa":"",
            "telefono_trabajo":"",
            "extension":"",
            "correo":"",
            "el_alumno_depende":false,
            "trabaja":true,
            "ocupacion":"",
            "empresa_donde_trabaja":"",
            "ultimo_grado_estudios":"",
            "parentesco":""
        },
        pos: 0,
        count: 0,
        headersBeca:[
            {name: "Beca", field: "beca"},
            {name: "Estatus", field: "status"},
            {name: "Ciclo Escolar", field: "ciclo"},
            {name: "Comentario", field: "comentario"}
        ],
        status: {
            1: 'Prospecto',
            2: 'Interesado',
            3: 'Aplicante',
            4: 'Admitido',
            5: 'Inscrito',
            6: 'Congelado',
            7: 'Descartado',
            10: 'No acreditado',
            11: 'Baja definitiva voluntaria',
            12: 'Baja definitiva por conducta',
            13: 'Baja temporal voluntaria',
            14: 'Suspensión por morosidad',
            15: 'Bloqueo para inscripción',
            16: 'Reactivación'
        },
        familiaresHijos: [],
        familiarVinculoSelected: {
            fullName: ''
        },
        enviarCorreoModal: {},
        ticketModal: {},
        userSelected: {},
        adjunto: null,
        comunicadoModal: {
            usuario_receptor: null,
            asunto: '',
            mensaje: ''
        },
        comView: 0,
        comMensajes: [],
        comSelected: null,
    }},
    mounted() {
        const vm = this;
        const enviarCorreoForm = $('#enviarCorreoForm');
        const ticketForm = $('#ticketModalFormId');
        const fileInput = $('#fileInput');

        this.reload();

        this.$on('refreshTabs', function(id) {
            $('#pills-estudiantil').tab('show');
        });
        this.$on('refresh', function(id) {
            vm.reload();
        });
        this.$on('avatarChange', function(avatar) {
            if(this.lista.length > 0) {
                this.data.avatar = avatar;
                this.lista[this.pos].avatar = avatar;
                this.menu[this.pos].avatar = avatar;
            }
        });

        this.$on('docChange', function(res) {
            this.data.documentos.forEach(element => {
                if(element.id == res.documento_id) {
                    element.archivo = res;
                }
            });
        });

        enviarCorreoForm.submit(function(event) {
            event.preventDefault();
            vm.enviarCorreo();
        });

        ticketForm.submit(function(event) {
            event.preventDefault();
            vm.nuevoTicket();
        });

        $('#postTicketModalId').on('hidden.bs.modal', function (e) {
            vm.userSelected = {};
            vm.adjunto = null;
        })

        fileInput.on('change', function(e) {
            const formData = new FormData();
            formData.append('adjunto', e.target.files[0])
            vm.adjunto = formData;
        });

        $('#mensajeFormId').submit(function(event) {
            event.preventDefault();
            vm.nuevoComunicado();
        })
    },
    methods: {
        comResponder() {
            if(this.comunicadoModal.mensaje != '') {
                Axios.post('/panel/alumno/responderComunicado', {
                    comunicado_id: this.comSelected.id,
                    mensaje: this.comunicadoModal.mensaje,
                }).then(res => {
                    this.comMensajes.push(res.data);
                    this.comunicadoModal.mensaje = '';
                    toastr["success"]('Mensaje enviado', "Éxito");
                }).catch(e => {
                    toastr["error"]('Ocurrió un problema inesperado', 'Error');
                });
            }
        },
        comBack() {
            this.comView = 0;
            this.comMensajes = [];
            this.comSelected = null;
        },
        formatearFecha(fecha) {           
            return moment(String(fecha)).fromNow()
        },
        selectCom(com_index) {
            this.comSelected = this.data.comunicados[com_index];
            this.comMensajes = this.data.comunicados[com_index].mensajes;
            this.comView = 1;
        },
        nuevoComunicado() {
            this.comunicadoModal.persona_id = this.data.persona_id;
            this.comunicadoModal.familiares_id = this.data.receptores;
            Axios.post('/panel/alumno/nuevoComunicado', this.comunicadoModal).then(res => {
                $('#nuevoMensajeModalId').modal('hide');
                this.comunicadoModal.mensaje = '';
                this.comunicadoModal.asunto = '';
                toastr["success"]('Mensaje enviado', "Éxito");
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        reload() {
            if(this.ruta == "false") {
                this.getProspecto('usuario/get', false);
            } else {
                this.getProspecto(this.ruta, true)   ;
            }
        },
        nuevoTicket() {
            this.ticketModal.user_id = this.userSelected.id;
            this.ticketModal.departamento_id = 1;
            Axios.post('/soporte-admin/nuevoTicket', this.ticketModal).then(res => {
                if(this.adjunto) {
                    this.adjuntarArchivo(res.data.mensaje.id);
                }
                toastr["success"]('Ticket registrado con éxito', "Éxito");
                $('#postTicketModalId').modal('hide');
                this.userSelected = {};
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        adjuntarArchivo(mensaje_id) {
            axios.post('/soporte-admin/adjuntarArchivo/'+mensaje_id, this.adjunto, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(res => {
                this.adjunto = null;
            }).catch(e => {
                console.log(e);
            });
        },
        abrirTicketModal(user) {
            this.userSelected = user;
            $('#postTicketModalId').modal('show');
        },
        getProspecto(url, ruta) {
            setTimeout(() => {
                Axios.get(url).then(res => {
                    if(ruta == true) {
                        let registros_filtrados = [];
                        this.data = res.data;

                        if( this.data.registros_academicos )
                            this.data.registros_academicos.forEach(element => {
                                if( element.institucion_id == this.institucion_filtro )
                                    registros_filtrados.push(element);
                            });
                        
                        if( registros_filtrados.length == 0 )
                            this.data.tipo = this.data.persona_id ? 'persona' : 'prospecto';
                        else
                            this.data.tipo = 'alumno';

                        this.$emit('externalFormReady');
                    } else {
                        this.lista = res.data;
                        this.data = this.lista[this.pos];
                        this.count = this.lista.length;
                        for (let index = 0; index < this.lista.length; index++) {
                            const element = this.lista[index];
                            this.menu.push({pos: index, nombres: element.nombres, avatar: element.avatar});
                        }
                    }
                    if(res.data.receptores) {
                        res.data.receptores.forEach(item => { 
                            $('#receptores_crear').append('<option value="'+item.id+'">'+item.text+'</option>')
                        });
                        $('#receptores_crear').selectpicker('refresh');
                    }
                });
            }, 0);
        },
        avanzar(id) {
            this.mover('/panel/avanzar/'+id);
        },
        retroceder(id) {
            this.mover('/panel/retroceder/'+id);
        },
        congelar(id) {
            this.mover('/panel/congelar/'+id);
        },
        descartar(id) {
            this.mover('/panel/descartar/'+id);
        },
        reactivar(etapa, id) {
            this.mover('/panel/reactivar/'+etapa+'/'+id);
        },
        mover(url) {
            axios.post(url).then(res => {
                //this.data['status_id'] = res.data.status_id;
                this.data = res.data;
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        navegar(posicion) {
            if(this.pos != posicion) {
                this.pos = posicion;
                this.data = this.lista[this.pos];
            }
        },
        crearFamiliar() {
            this.af.persona_id = this.data.persona_id;
            this.af.prospecto_id = this.data.id;
            axios.post('/panel/crearFamiliar', this.af).then(res => {
                if(this.data.familiares.length > 0) {
                    this.data.familiares = this.data.familiares.concat(res.data);
                } else {
                    this.data.familiares = [res.data];
                }
                this.$emit('kiraModalFormClose');
                this.af = {};
                this.af.parentesco = 'padre';
                toastr["success"]('Nuevo familiar agregado', "Éxito");
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        editarFamiliar() {
            axios.post('/panel/editarFamiliar', this.af).then(res => {
                let index = this.data.familiares.findIndex(item => item.id == res.data.id);
                this.data.familiares[index] = res.data;
                toastr["success"]('Registro actualizado', "Éxito");
                this.$emit('kiraModalFormClose');
                this.af = {};
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        comentar(id) {
            axios.post('/panel/comentar/'+id, {comentario: this.vars.comentario}).then(res => {
                this.data.comentarios.unshift({
                    id: res.data.id,
                    comentario: res.data.comentario,
                    created_at: res.data.created_at,
                    status_id: res.data.status_id,
                    nuevo: true,
                    user: {
                        id: res.data.user.id,
                        name: res.data.user.name
                    }
                })
                this.vars.comentario = '';
            }).catch(e => {

            });
        },
        sendResetPassword(id) {
            axios.get('/panel/usuario/reset-password/'+id).then(res => {
                toastr["success"]('Se envió el email', "Éxito");
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        desvincularUsuario(id, persona_id) {
            axios.get('/panel/usuario/desvincularUser/'+id+'/'+persona_id).then(res => {
                toastr["success"]('Se desvinculo el usuario correctamente', "Éxito");
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        crearAccesosLanding(id, tipo) {
            axios.get(`/panel/usuario/crear-accesos/${id}`, {
                params: { tipo: tipo }
            }).then(res => {
                toastr["success"]('Se generaron los accesos', "Éxito");
                this.reload();
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        siguiente() {
            if(this.pos+1 < this.lista.length) {
                this.pos++;
                this.data = this.lista[this.pos];
                if(this.data.tipo == 'persona') {
                    this.$emit('refreshTabs', '#pills-estudiantil');
                }
            }
        },
        anterior() {
            if(this.pos > 0) {
                this.pos--;
                this.data = this.lista[this.pos];
            }
        },
        seleccionarFamiliar(id) {
            let index = this.data.familiares.findIndex(item => item.id == id);
            //this.familiarSelected = index;
            this.af = this.data.familiares[index];
        },
        seleccionarTutor(familiar_id, id, persona_id) {
            axios.post('/panel/establecerTutor', {
                familiar_id: familiar_id,
                persona_id: persona_id,
                prospecto_id: id,
            }).then(res => {
                toastr["success"]('Se estableció a ' + res.data.nombre + ' como tutor.', "Éxito");
                this.data.tutor_id = res.data.tutor_id;
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        limpiar() {
            this.af.apellido_paterno = '';
            this.af.apellido_materno = '';
            this.af.nombres = '';
            this.af.celular = '';
            this.af.telefono_casa = '';
            this.af.telefono_trabajo = '';
            this.af.extension = '';
            this.af.correo = '';
            this.af.el_alumno_depende = false;
            this.af.trabaja = false;
            this.af.ocupacion = '';
            this.af.empresa_donde_trabaja = '';
            this.af.ultimo_grado_estudios = '';
        },
        desvincularFamiliar(familiar) {
            this.familiarVinculoSelected = familiar;
            axios.get('/panel/desvincularFamiliar/'+familiar.id).then(res => {
                this.familiaresHijos = res.data.hijos;
                $('#desvincularFamiliarId').modal('show');
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        quitarVinculo() {
            console.log('quitando vinculo', this.data.prospecto_id);
            axios.post('/panel/quitarVinculo', {
                familiar_id: this.familiarVinculoSelected.id,
                persona_id: this.data.persona_id,
                prospecto_id: this.data.id,
            }).then(res => {
                const index =this.data.familiares.findIndex(f => f.id == this.familiarVinculoSelected.id);
                this.data.familiares.splice(index, 1);
                $('#desvincularFamiliarId').modal('hide');
                toastr["success"]('Se desvinculó el familiar ' + this.familiarVinculoSelected.fullName, "Éxito");
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        abrirCorreoModal(status_id) {
            this.enviarCorreoModal.status_id = status_id;
            this.enviarCorreoModal.prospecto_id = this.data.id;
            $('#enviarCorreoModal').modal('show');
        },
        enviarCorreo() {
            Axios.post('/panel/enviarCorreo', this.enviarCorreoModal).then(res => {
                this.data['correos'].push(res.data);
                $('#enviarCorreoModal').modal('hide');
                this.enviarCorreoModal.asunto = '';
                this.enviarCorreoModal.mensaje = '';
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        }
    },
}
</script>
